import { FormField } from "@/components/common/FormField";
import { PhoneField } from "@/components/common/PhoneField";

const PERSONAL_FIELDS = [
  { field: "name", label: "Your name", testId: "inquiry-name", placeholder: "Jordan Rivera" },
  { field: "email", label: "Email", testId: "inquiry-email", placeholder: "you@company.com", type: "email" },
];
const EMPLOYER_FIELDS = [
  { field: "organisation", label: "Company name", testId: "inquiry-organisation", placeholder: "Acme Inc." },
  { field: "jobTitle", label: "Job title / designation (optional)", testId: "inquiry-jobtitle", placeholder: "Head of Talent" },
];
const FREELANCER_FIELDS = [
  { field: "expertise", label: "Primary expertise", testId: "inquiry-expertise", placeholder: "e.g., Brand & Web Design" },
  { field: "experience", label: "Experience", testId: "inquiry-experience", placeholder: "e.g., 5 years" },
];
const FREELANCER_LOCATION_FIELDS = [
  { field: "location", label: "Location / time zone (optional)", testId: "inquiry-location", placeholder: "e.g., Bengaluru, IST" },
  { field: "portfolio", label: "Portfolio / website (optional)", testId: "inquiry-portfolio", placeholder: "https://…" },
];
const TARGET_FIELD = { field: "targetRole", label: "Target role / career goal", testId: "inquiry-target", placeholder: "e.g., Senior Product Manager" };

const InquiryInput = ({ definition, journey }) => {
  const { field, label, testId, placeholder, type = "text" } = definition;
  return (
    <FormField label={label} error={journey.errors[field]} testId={testId}>
      <input type={type} className="scc-input" value={journey.form[field]} data-testid={testId}
        onChange={(event) => journey.updateField(field, event.target.value)} placeholder={placeholder} />
    </FormField>
  );
};

const InputPair = ({ fields, journey }) => (
  <div className="grid gap-5 md:grid-cols-2">
    {fields.map((definition) => <InquiryInput key={definition.field} definition={definition} journey={journey} />)}
  </div>
);

const PathFields = ({ journey }) => {
  if (journey.pathId === "employer") return <InputPair fields={EMPLOYER_FIELDS} journey={journey} />;
  if (journey.pathId === "candidate") return <InquiryInput definition={TARGET_FIELD} journey={journey} />;
  if (journey.pathId === "freelancer") return (
    <>
      <InputPair fields={FREELANCER_FIELDS} journey={journey} />
      <InputPair fields={FREELANCER_LOCATION_FIELDS} journey={journey} />
    </>
  );
  return null;
};

export const InquiryFields = ({ journey }) => (
  <>
    <InputPair fields={PERSONAL_FIELDS} journey={journey} />
    <div className="grid gap-5 md:grid-cols-2">
      <FormField label="Phone number" error={journey.errors.phone} testId="inquiry-phone">
        <PhoneField dial={journey.form.phoneDial} number={journey.form.phone} testId="inquiry-phone"
          onDial={(value) => journey.updateField("phoneDial", value)} onNumber={(value) => journey.updateField("phone", value)} />
      </FormField>
      <FormField label="Preferred contact method" testId="inquiry-preferred">
        <select className="scc-input" value={journey.form.preferredContact} data-testid="inquiry-preferred"
          onChange={(event) => journey.updateField("preferredContact", event.target.value)}>
          <option value="email">Email</option><option value="phone">Phone</option>
        </select>
      </FormField>
    </div>
    <PathFields journey={journey} />
  </>
);